import React, { useEffect, useState } from 'react'
import { Slider } from '@/components/ui/slider'

export type BroadnessFilterProps = {
  value?: number
  onChange?: (value?: number) => void
}

export default function BroadnessFilter({ value: initialValue, onChange = () => {} }: BroadnessFilterProps) {
  const [value, setValue] = useState<number | undefined>(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return (
    <div>
      {/* Force re-render when value changes by using the key prop */}
      <Slider
        variant={'light'}
        key={`broadness-slider-${value}`}
        min={0}
        max={4}
        step={1}
        defaultValue={value ? [value] : undefined}
        onValueCommit={(values) => {
          onChange(values[0])
        }}
      />
    </div>
  )
}
